// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"zX-z","sponsoredTooltipWrapper":"AX-z","sponsoredTooltip":"BX-z","newCard":"CX-z"};